var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon_header_sub"},[_c('div',{staticClass:"icon-con"},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("info")])],1),_c('div',{staticClass:"text-con"},[_c('h2',[_vm._v("Whats new?")]),_c('p',{staticClass:"text-light"},[_vm._v(_vm._s(_vm.sub))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }